import {
  GET_ALL_LRS_PROJECTS,
  GET_ALL_LRS_PROJECTS_SUCCESS,
  GET_ALL_LRS_PROJECTS_ERROR,
  GET_LRS_PROJECT_PROCEDURES,
  GET_LRS_PROJECT_PROCEDURES_SUCCESS,
  GET_LRS_PROJECT_PROCEDURES_ERROR,
  GET_ALL_VPIN_PROJECTS,
  GET_ALL_VPIN_PROJECTS_SUCCESS,
  GET_ALL_VPIN_PROJECTS_ERROR,
} from './types';

const initialState = {
  lrs: {
    projects: [],
    procedures: {}, // keyed by a project's requestNumber; shape: { data: [], dataLoaded: boolean, error: boolean }
    isLoading: false,
    isError: false,
  },
  vpin: {
    projects: [],
    isLoading: false,
    isError: false,
  },
};

export const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case GET_ALL_VPIN_PROJECTS:
      return {
        ...state,
        vpin: {
          ...state.vpin,
          isLoading: true,
        },
      };
    case GET_ALL_VPIN_PROJECTS_SUCCESS:
      return {
        ...state,
        vpin: {
          ...state.vpin,
          projects: action.payload || [],
          isLoading: false,
          isError: false,
        },
      };
    case GET_ALL_VPIN_PROJECTS_ERROR:
      return {
        ...state,
        vpin: {
          ...state.vpin,
          isLoading: false,
          isError: true,
        },
      };
    case GET_ALL_LRS_PROJECTS:
      return {
        ...state,
        lrs: {
          ...state.lrs,
          isLoading: true,
        },
      };
    case GET_ALL_LRS_PROJECTS_SUCCESS:
      return {
        ...state,
        lrs: {
          ...state.lrs,
          projects: action.payload || [],
          isLoading: false,
          isError: false,
        },
      };
    case GET_ALL_LRS_PROJECTS_ERROR:
      return {
        ...state,
        lrs: {
          ...state.lrs,
          isLoading: false,
          isError: true,
        },
      };
    case GET_LRS_PROJECT_PROCEDURES:
      return {
        ...state,
        lrs: {
          ...state.lrs,
          procedures: {
            ...state.lrs.procedures,
            [action.requestNumber]: {
              data: [],
              dataLoaded: false,
              error: false,
            },
          },
        },
      };
    case GET_LRS_PROJECT_PROCEDURES_SUCCESS:
      return {
        ...state,
        lrs: {
          ...state.lrs,
          procedures: {
            ...state.lrs.procedures,
            [action.requestNumber]: {
              data: action.procedures || [],
              dataLoaded: true,
              error: false,
            },
          },
        },
      };
    case GET_LRS_PROJECT_PROCEDURES_ERROR:
      return {
        ...state,
        lrs: {
          ...state.lrs,
          [action.requestNumber]: {
            data: [],
            dataLoaded: true,
            error: true,
          },
        },
      };
    default:
      return state;
  }
}